<template>
  <div>
    <el-row
      v-for="(item, index) in zones"
      :key="index"
      class="data-user">
      <el-col :span="1">
        <div
          :style="{backgroundColor: item.colorZone}"
          class="color-zone"/>
      </el-col>
      <el-col
        :span="13"
        class="name-ticket-and-zone">
        <h1>{{ item.nameZone }}</h1>
        <span>{{ item.nameSection }}</span><br>
        <span>{{ item.numberSection }}</span>
      </el-col>
      <el-col
        :span="3"
        class="name-ticket-and-zone">
        <h1>Precio</h1>
        <span>${{ item.price }}</span>
      </el-col>
      <el-col
        :span="3"
        class="name-ticket-and-zone">
        <h1>Subtotal</h1>
        <span>${{ item.price + item.serviceCharge }}</span>
      </el-col>
      <el-col
        :span="4"
        class="name-ticket-and-zone">
        <h1>Cargo por servicio</h1>
        <span>${{ item.serviceCharge }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col class="total">
        <h1>Total: MXN${{ priceFinal }}</h1>
        <span>IVA incluido</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'MtDetailsPurchases',
  data () {
    return {
      zones: [
        {
          colorZone: '#FFC503',
          nameZone: 'Zona lorem ipsum dolor sit amet',
          nameSection: 'Aqui la seccion',
          numberSection: 'Z350',
          price: 35000,
          serviceCharge: 350
        },
        {
          colorZone: '#51B364',
          nameZone: 'Zona lorem ipsum dolor sit amet',
          nameSection: 'Aqui la seccion',
          numberSection: 'Z352',
          price: 35000,
          serviceCharge: 350
        },
        {
          colorZone: '#AC65FF',
          nameZone: 'Zona lorem ipsum dolor sit amet',
          nameSection: 'Aqui la seccion',
          numberSection: 'Z354',
          price: 35000,
          serviceCharge: 350
        },
        {
          colorZone: '#FF5819',
          nameZone: 'Zona lorem ipsum dolor sit amet',
          nameSection: 'Aqui la seccion',
          numberSection: 'Z356',
          price: 35000,
          serviceCharge: 350
        }
      ]
    }
  },
  computed: {
    priceFinal () {
      return this.zones.reduce((price, item) => price + item.price + item.serviceCharge, 0)
    }
  }
}
</script>

<style lang="scss" scoped>

  .data-user{
    padding: 30px 0 30px 0;
    border-bottom: 1px solid #E3E6EA;
  }

  .color-zone{
    border-radius: 2px;
    width: 20px;
    height: 20px;
  }

  .name-ticket-and-zone{
    h1{
      margin: 0 0 3px 0;
      @include font-primary(14px, semibold);
      color: $carbon;
    }
    span{
      color: $carbon;
      &:not(:last-child){
        @include font-primary(12px, semibold);
      }
    }
  }
  .total{
    margin-top: 20px;
    h1{
      margin: 0;
      @include font-primary(14px, semibold);
      color: $carbon;
    }
    span{
      @include font-primary(10px, semibold);
      color: #999999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/mt-details-purchases.vue